import styled from 'styled-components'
import { SIZES } from '../../../constants'

export default styled.div`
  flex: 1 1 0%;
  @media (min-width: ${SIZES.BREAKPOINT_MD}px) {
    max-width: 300px;
  }
`
